export class DialogAttributes {
    constructor() {
    }
}
